import { ModelView } from "../model.view";
import {
  BudgetStoreModel,
  BudgetModelVersion,
  DefaultBudgetStoreModel,
} from "@bitwarden/web-vault/app/models/store/budget.store.model";
import {
  BudgetIntervalType,
  BudgetSpreadType,
} from "@bitwarden/web-vault/app/models/types/budget.types";
import {
  CategoriesLinkedProperties,
  LinkedProperty,
  LinkedView,
} from "@bitwarden/web-vault/app/models/view/linked.property";
import { CurrencyType } from "@bitwarden/web-vault/app/models/types/location-currency.types";

export class BudgetView
  extends ModelView<BudgetStoreModel>
  implements LinkedProperty<CategoriesLinkedProperties>
{
  protected version: BudgetModelVersion;
  name: string;
  amount: number;
  currency?: CurrencyType | null;
  interval: BudgetIntervalType;
  startDate: Date;
  endDate: Date;
  spread: BudgetSpreadType;
  startingPreference: number;
  categoriesLink: LinkedView[];

  constructor(model?: BudgetStoreModel) {
    super(model);

    if (typeof model === "object") {
      this.name = model.nm;
      this.amount = model.am;
      this.currency = model.cur;
      this.interval = model.int;
      this.startDate = model.sdt ? new Date(model.sdt) : null;
      this.endDate = model.edt ? new Date(model.edt) : null;
      this.spread = model.spd;
      this.startingPreference = model.stp;
      this.categoriesLink = model.ctId ? model.ctId.map((id) => ({ id: id })) : [];
    } else {
      this.version = DefaultBudgetStoreModel.v;
      this.currency = DefaultBudgetStoreModel.cur;
      this.interval = "monthly";
      this.startingPreference = 1;
      this.spread = "continuous";
    }
  }

  toStoreModel(): BudgetStoreModel {
    return {
      id: this.id,
      vid: this.vaultId,
      v: this.version,
      dc: this.dateCreated.toISOString(),
      dm: this.dateModified.toISOString(),
      nm: this.name,
      am: this.amount,
      cur: this.currency,
      int: this.interval,
      sdt: this.startDate,
      edt: this.endDate,
      spd: this.spread,
      stp: this.startingPreference,
      ctId: this.categoriesLink.map((link) => link.id),
    };
  }

  clone(): BudgetView {
    return new BudgetView(this.toStoreModel());
  }
}
